// removed by extract-text-webpack-plugin
module.exports = {"submenu-container":"_37_lxOLMewtDtfhC4f9U5g","submenuContainer":"_37_lxOLMewtDtfhC4f9U5g","back-button-box":"LKuYXFDDVf60DS05DNUCI","backButtonBox":"LKuYXFDDVf60DS05DNUCI","back-button":"_38Xgr_geuWFmPb3Obov-Ha","backButton":"_38Xgr_geuWFmPb3Obov-Ha","submenu-title":"vv-YlUXRAcJmigVUVOAzb","submenuTitle":"vv-YlUXRAcJmigVUVOAzb"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/header/submenuOverlay.css
// module id = 524
// module chunks = 0